import { lazy } from 'react';

import AuthGuard from 'components/AuthGuard';
import DashboardLayout from 'layouts/DashboardLayout';

const error404 = {
  component: lazy(() => import('views/Errors/Error404')),
};

const dashboardRoutes = {
  path: '/',
  guard: AuthGuard,
  layout: DashboardLayout,
  routes: [
    {
      exact: true,
      path: '/aggregator',
      component: lazy(() => import('views/Aggregator/List')),
    },
    // Onboarding: cola de expedientes KYC y detalle. El orden importa, la
    // ruta exacta va antes que la paramétrica.
    {
      exact: true,
      path: '/onboarding',
      component: lazy(() => import('views/Onboarding/List')),
    },
    {
      exact: true,
      path: '/onboarding/:id',
      component: lazy(() => import('views/Onboarding/Detail')),
    },
    {
      exact: true,
      path: '/aggregator/add',
      component: lazy(() => import('views/Aggregator/Add')),
    },
    {
      exact: true,
      path: '/terminals',
      component: lazy(() => import('views/Terminals/List')),
    },
    {
      exact: true,
      path: '/terminals/add',
      component: lazy(() => import('views/Terminals/Add')),
    },
    {
      exact: true,
      path: '/monitoring',
      component: lazy(() => import('views/Monitoring/List')),
    },
    {
      exact: true,
      path: '/commerce',
      component: lazy(() => import('views/Commerce/List')),
    },
    {
      exact: true,
      path: '/commerce/add',
      component: lazy(() => import('views/Commerce/Add')),
    },
    {
      exact: true,
      path: '/commerce/edit',
      component: lazy(() => import('views/Commerce/Edit')),
    },
    {
      exact: true,
      path: '/transactions',
      component: lazy(() => import('views/Transactions/List')),
    },
    {
      exact: true,
      path: '/users',
      component: lazy(() => import('views/Users/List')),
    },
    {
      component: lazy(() => import('views/Reports/List')),
      exact: true,
      path: '/reports',
      permission: 'reports.select.listReports',
    },
    {
      exact: true,
      path: '/pos',
      component: lazy(() => import('views/POS')),
    },
    {
      component: lazy(() => import('views/Liquidation')),
      exact: true,
      path: '/liquidation',
    },
    error404,
  ],
};

export default dashboardRoutes;
